import axiosInstance from './axiosInstance'

// ── Types ─────────────────────────────────────────────────────────────────────

export interface LobContext {
  id:   string
  name: string
}

export interface OrgContext {
  id:   string
  name: string
  lobs: LobContext[]
}

// ── API ───────────────────────────────────────────────────────────────────────

/**
 * GET /context/orgs
 *
 * Returns the orgs + LOBs the caller can access:
 *   SUPER_ADMIN  → all orgs + all LOBs
 *   ORG_ADMIN    → their org + all its LOBs
 *   Normal User  → their org + their assigned LOB only
 *
 * Used to populate the nav bar org/LOB selector and to display org/LOB names.
 */
export const getOrgContext = async (): Promise<OrgContext[]> => {
  const res = await axiosInstance.get<{ data: OrgContext[] }>('/context/orgs')
  return res.data.data ?? []
}
